import { useRouter } from "next/router";

import { twMerge } from "tailwind-merge";
import { useTimeout } from "usehooks-ts";

import CustomCard from "components/CustomCard";
import useSignInSignUp from "components/SignInSignUpModal/useSignInSignUp";
import { Tab, Tabs } from "components/Tabs";
import useAuthentication from "hooks/useAuthentication";
import useMediaQuery from "hooks/useMediaQuery";

import DashboardPageInsightsList from "../DashboardPageInsightList";

type DashboardPageFollowedProps = {};

const DashboardPageFollowed = ({}: DashboardPageFollowedProps) => {
  const router = useRouter();
  const collection = router.query.collection as string;

  const { authenticated } = useAuthentication();
  const { toggleModal } = useSignInSignUp();
  const { mobile } = useMediaQuery();

  const description =
    collection === "from-all-followed"
      ? "Follow your favourite authors, collections and never miss an update"
      : collection === "from-ip-i-follow"
      ? "Follow your favourite authors and never miss an update"
      : "Follow your favourite collections and never miss an update";

  useTimeout(() => {
    if (!authenticated) toggleModal("sign-up");
  }, 15000);

  return (
    <>
      {!mobile && (
        <Tabs className="pt-[60px]">
          <Tab
            href="/dashboard?collection=from-all-followed"
            active={collection === "from-all-followed"}
          >
            All
          </Tab>
          <Tab
            href="/dashboard?collection=from-ip-i-follow"
            active={collection === "from-ip-i-follow"}
            className="md:max-w-none"
          >
            Insight Providers
          </Tab>
          <Tab
            href="/dashboard?collection=followed-collections"
            active={collection === "followed-collections"}
          >
            Collections
          </Tab>
        </Tabs>
      )}
      {authenticated ? (
        <CustomCard className={twMerge("p-0 mt-[51px] md:mt-[15px]")}>
          <DashboardPageInsightsList
            options={{
              filter: { collection },
              showTopPicksToggle: true,
              showSearch: true,
            }}
          />
        </CustomCard>
      ) : (
        <CustomCard
          className={twMerge(
            "mt-[45px] md:mt-[15px] text-center italic text-[18px]"
          )}
        >
          <p>{description}.</p>
          <p>
            <span
              onClick={() => toggleModal("sign-up")}
              className="text-smart-teal hover:text-smart-teal cursor-pointer"
            >
              Sign up
            </span>{" "}
            to create your Free Preview Pass.
          </p>
        </CustomCard>
      )}
    </>
  );
};

export default DashboardPageFollowed;
